import { getRequestAction } from 'helpers/functions';

const ACTION_PREFIX = 'notification';

export const getNotificationList = getRequestAction(
  `${ACTION_PREFIX}/getNotificationList`
);

export const getEmployeeNotification = getRequestAction(
  `${ACTION_PREFIX}/getEmployeeNotification`
);

export const updateEmployeeNotification = getRequestAction(
  `${ACTION_PREFIX}/updateEmployeeNotification`
);

export const getCustomerNotification = getRequestAction(
  `${ACTION_PREFIX}/getCustomerNotification`
);

export const updateCustomerNotification = getRequestAction(
  `${ACTION_PREFIX}/updateCustomerNotification`
);
